/**
 * Extract value key from item
 * @param item
 * @param valueKey dot separated key path
 * @returns object value at key path
 */
export const extractValueKey = (item: any, valueKey: string) => {
  return valueKey.split('.').reduce((acc: any, key: any) => acc[key], item);
};
